import { render, staticRenderFns } from "./EditMensagemDialog.vue?vue&type=template&id=753f7531&"
import script from "./EditMensagemDialog.vue?vue&type=script&lang=js&"
export * from "./EditMensagemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports